import api from '../lib/api'

import { getScoutContext } from "./scout"

export const getPaymentHistory = async () => {
	const { enterpriseId } = getScoutContext()

	const response = await api.get(`payment_history/?enterpriseId=${enterpriseId}`)

	if (!response?.ok) {
		throw new Error("Erro ao carregar o histórico de pagamentos.")
	}

	return Array.isArray(response?.data) ? response.data : []
}
